import {
  MdmAvailableOsUpdatesResolverActions,
  MdmAvailableOsUpdatesApiActions,
} from './mdm-available-os-updates.actions';
import { Injectable } from '@angular/core';
import { AppleDevicesService } from '@rocksoft/mdm-sdk-v2';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';

@Injectable()
export class MdmAvailableOsUpdatesEffects {
  constructor(
    private readonly actions: Actions,
    private readonly appleDevicesService: AppleDevicesService
  ) {}

  mdmAvailableOsUpdatesRequestedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(MdmAvailableOsUpdatesResolverActions.availableOSUpdatesRequested),
      mergeMap(({ udid }) =>
        safeMap(
          this.appleDevicesService.getAvailableOsUpdates(udid, '2.0'),
          (availableOsUpdates) =>
            MdmAvailableOsUpdatesApiActions.availableOSUpdatesLoaded({
              availableOsUpdates: availableOsUpdates.map((availableOsUpdate) => ({
                ...availableOsUpdate,
                udid,
              })),
            }),
          (error) => MdmAvailableOsUpdatesApiActions.availableOSUpdatesLoadedError({ error })
        )
      )
    );
  });
}
